<template>
  <v-simple-table 
    class="rounded-lg simple-table elevation-1" dense
    :class="!$slots['action-bar'] ? 'simple-table--round-top' : ''"
  >
    <thead>
      <tr v-if="$slots['action-bar']" class="simple-table__action-bar">
        <slot name="action-bar" />
      </tr>
      <slot name="column-headers" />
    </thead>
      <slot />
  </v-simple-table>
</template>

<script>
export default {
  name: 'AppSimpleTable',

  props: {
    colspan: {
      type: [String, Number],
      default: 1,
    }
  }
}
</script>

<style scoped>
.simple-table {
  background-color: #DEDCFF !important;
}

::v-deep.simple-table thead > tr:not(.simple-table__action-bar) > th {
  background-color: #EBEAFF !important;
  border-radius: 0 !important;
  color: #66359B !important;
}

::v-deep.simple-table.simple-table--round-top thead > tr:not(.simple-table__action-bar) > th:first-of-type {
  border-radius: 0.5rem 0 0 0 !important;
}

::v-deep.simple-table.simple-table--round-top thead > tr:not(.simple-table__action-bar) > th:last-of-type {
  border-radius: 0 0.5rem 0 0 !important;
}

::v-deep.simple-table tbody > tr > td {
  background-color: #FFF !important;
}

::v-deep.simple-table tbody > tr > td:not(:last-of-type) {
  border-right: 1px solid #66359B;
}
</style>